import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_15.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/building');
  const shareText = encodeURIComponent('Building Workplaces People Choose HR Voices by Outstanding Workplaces!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Building Workplaces — Outstanding Workplaces</title>
        <meta property="og:title" content="Building Workplaces — Outstanding Workplaces" />
        <meta property="og:description" content="Building Workplaces People Choose HR Voices by Outstanding Workplaces" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778047566/i_15_jyngzf.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/building" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Building Workplaces  — Outstanding Workplaces" />
        <meta name="twitter:description" content="Building Workplaces People Choose HR Voices by Outstanding Workplaces" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778047566/i_15_jyngzf.jpg" />
      </Helmet>

         <div className="sight_15_page_wrapper">
        <div className="sight_15_content_container">

          <div className="sight_15_section_one">

            {/* TITLE */}
            <h1 className="sight_15_page_title">
              Building Workplaces People Choose HR Voices by Outstanding Workplaces
            </h1>

            {/* ROW */}
            <div className="sight_15_row">

              {/* LEFT */}
              <div className="sight_15_left">
                <div className="sight_15_image_wrapper">
                  <img src="/assets/i_15.jpg" alt="Team meeting discussion" className="sight_15_blog_image" />
                </div>




                {/* SHARE SECTION */}
                <div className="sight_15_share_section">
                  <span className="sight_15_share_text">Share :</span>
                  <div className="sight_15_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_15_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_15_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_15_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_15_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_15_intro_wrapper">
  <p className="sight_15_intro_paragraph p1">
    In today’s competitive talent landscape, attracting and retaining the right talent goes far beyond compensation and job titles. Organizations are now defined by how they are perceived - not just by customers, but by current and future employees.
  </p>

  <p className="sight_15_intro_paragraph p2">
    This is where employer branding becomes a game - changer.
  </p>

  <p className="sight_15_intro_paragraph p3">
    At HR Voices by Outstanding Workplaces, employer branding is a key conversation shaping how organizations position themselves as workplaces of choice.
  </p>
</div>

              </div>

              {/* RIGHT */}
              <div className="sight_15_right">
                <div className="sight_15_ad_card">
                  <img src="/assets/bc_1.png" className="sight_15_ad_bg" />
                  <div className="sight_15_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_15_ad_badge" />

                  <div className="sight_15_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>

                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>

                    <button
                      className="sight_15_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>




          {/* ===== SECTION TWO ===== */}
          <div className="sight_15_section">

            <div className="sight_15_topics">

<div className="sight_15_topic_item">
  <h2 className="sight_15_topic_heading">
    What is Employer Branding Today?
  </h2>

  {/* Intro */}
  <p className="sight_15_intro">
    Employer branding is no longer just about a careers page or social media presence. It is the complete experience an employee has with your organization - from first interaction to long-term growth.
  </p>

  {/* Label before list */}
  <p className="sight_15_label">
    It reflects:
  </p>

  {/* List */}
  <ul className="sight_15_topic_list">
    <li>Your workplace culture</li>
    <li>Leadership values</li>
    <li>Employee experience</li>
    <li>Growth and learning opportunities</li>
    <li>Commitment to wellbeing and inclusion</li>
  </ul>

  {/* Closing line */}
  <p className="sight_15_description">
    Simply put, your employer brand is what people say about your organization when you’re not in the room.
  </p>
</div>



<div className="sight_15_topic_item">
  <h2 className="sight_15_topic_heading">
    Why Employer Branding Matters
  </h2>

  {/* Label before list */}
  <p className="sight_15_label">
    In a world where talent has more choices than ever, a strong employer brand helps organizations:
  </p>

  {/* List */}
  <ul className="sight_15_topic_list">
    <li>Attract high-quality talent aligned with company values</li>
    <li>Reduce hiring costs and time-to-fill roles</li>
    <li>Improve employee retention and engagement</li>
    <li>Build trust and credibility in the market</li>
    <li>Strengthen overall business performance</li>
  </ul>

  {/* Closing line */}
  <p className="sight_15_description">
    Organizations with strong employer brands don’t chase talent — talent seeks them out.
  </p>
</div>




<div className="sight_15_topic_item">
  <h2 className="sight_15_topic_heading">
    The Role of HR in Shaping the Brand
  </h2>

  {/* Intro */}
  <p className="sight_15_intro">
    HR leaders today are brand builders. They play a critical role in ensuring that the organization’s internal culture aligns with its external image.
  </p>

  {/* Label before list */}
  <p className="sight_15_label">
    At HR Voices, discussions focus on how HR can:
  </p>

  {/* List */}
  <ul className="sight_15_topic_list">
    <li>Craft authentic employee value propositions (EVP)</li>
    <li>Amplify employee voices and stories</li>
    <li>Leverage digital platforms to showcase culture</li>
    <li>Align leadership behavior with brand promises</li>
    <li>Measure and improve employee experience continuously</li>
  </ul>

  {/* Closing line */}
  <p className="sight_15_description">
    Employer branding is not a campaign — it is a continuous, lived experience.
  </p>
</div>




<div className="sight_15_topic_item">
  <h2 className="sight_15_topic_heading">
    From Promise to Reality
  </h2>

  {/* Intro */}
  <p className="sight_15_intro">
    One of the biggest challenges organizations face is the gap between what they promise and what employees actually experience.
  </p>

  {/* Label before list */}
  <p className="sight_15_label">
    Strong employer brands are built when:
  </p>

  {/* List */}
  <ul className="sight_15_topic_list">
    <li>Words match actions</li>
    <li>Leaders lead by example</li>
    <li>Employees feel heard and valued</li>
    <li>Culture is consistent across all levels</li>
  </ul>

  {/* Closing line */}
  <p className="sight_15_description">
    Authenticity is the foundation of a credible employer brand.
  </p>
</div>



<div className="sight_15_topic_item">
  <h2 className="sight_15_topic_heading">
    The Power of Employee Advocacy
  </h2>

  {/* Intro */}
  <p className="sight_15_intro">
    Employees are the most powerful ambassadors of any organization. Their stories, experiences, and voices shape how the outside world perceives your workplace.
  </p>

  {/* Label before list */}
  <p className="sight_15_label">
    Encouraging employee advocacy leads to:
  </p>

  {/* List */}
  <ul className="sight_15_topic_list">
    <li>Stronger brand credibility</li>
    <li>Greater reach and visibility</li>
    <li>More meaningful talent connections</li>
  </ul>

  {/* Closing line */}
  <p className="sight_15_description">
    When employees speak positively about their workplace, it creates trust that no marketing campaign can replicate.
  </p>
</div>


<div className="sight_15_topic_item">
  <h2 className="sight_15_topic_heading">
    The Future of Employer Branding
  </h2>

  {/* Label before list */}
  <p className="sight_15_label">
    As the workplace continues to evolve, employer branding will be driven by:
  </p>

  {/* List */}
  <ul className="sight_15_topic_list">
    <li>Transparency and authenticity</li>
    <li>Focus on employee wellbeing</li>
    <li>Commitment to diversity, equity, and inclusion</li>
    <li>Flexible and hybrid work environments</li>
    <li>Continuous learning and growth opportunities</li>
  </ul>

  {/* Closing line */}
  <p className="sight_15_description">
    Organizations that adapt to these expectations will stand out in the talent market.
  </p>
</div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;

